/** Dünyada Rotary — YouTube gömülü oynatıcı. Metinler i18n: `rotaryWorldwide.*`. */
export const ROTARY_WORLDWIDE_VIDEO_EMBED_SRC =
    'https://www.youtube.com/embed/mJ2T1G1WWTo?si=NxgG6pvAY4RvpZoJ';
